import { Pause, Play, ShoppingBag } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { usePlayer } from "@/context/PlayerContext";
import { resolveImg } from "@/lib/api";

export default function PostMedia({ post, onBuy }) {
  const { t } = useI18n();
  const { current, playing, playTrack, togglePlay } = usePlayer();
  const track = post.track;
  const isCurrent = track && current?.id === track.id;
  const isPlaying = isCurrent && playing;

  if (!post.image) return null;

  const handlePlay = () => {
    if (!track) return;
    if (isCurrent) togglePlay();
    else playTrack(track, [track]);
  };

  return (
    <div className="relative aspect-[4/5] sm:aspect-video w-full bg-zinc-950">
      <img src={resolveImg(post.image)} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none" />
      {track && (
        <div className="absolute bottom-3 left-3 right-3 flex items-center gap-3 bg-black/50 backdrop-blur-xl rounded-2xl p-3 border border-white/10">
          <button
            onClick={handlePlay}
            className="w-11 h-11 rounded-full bg-white text-black grid place-items-center active:scale-95 transition-transform"
            data-testid={`post-play-${post.id}`}
            aria-label="play track"
          >
            {isPlaying ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 ml-0.5" />}
          </button>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-semibold text-white">{track.title}</p>
            <p className="truncate text-xs text-zinc-400">
              {track.artist_name} · {track.is_free ? "Gratuit" : `$${track.price.toFixed(2)}`}
              {track.owned ? " · Achetée" : !track.is_free && track.price > 0 ? ` · extrait ${track.preview_duration || 30} s` : ""}
            </p>
          </div>
          {!track.owned && (
            <button
              onClick={() => onBuy && onBuy(track)}
              className="hidden sm:inline-flex items-center gap-1 btn-primary py-2 px-4 text-xs"
              data-testid={`post-buy-${post.id}`}
            >
              <ShoppingBag className="w-4 h-4" />
              {t.store.buy}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
